import { createContext, type RefObject } from 'react';

import { _SelectionRef } from '../../core/components/selection-area/types.js';

export const XYChartSelectionAreaRefContext = createContext<
  RefObject<_SelectionRef> | undefined
>(undefined);
